import {
	FETCH_NI_SMELTER_DATA_INIT,
	FETCH_NI_SMELTER_DATA,
	RESET_NI_SMELTER_DATA,
	FETCH_NI_SMELTER_DATA_ERR
} from '../../actions';

const INITIAL_STATE = {
	timestamp: '',
	data: '',
	error: ''
};

//response is valid if request timestamp is fresher
function isResponseValid(t1, t2) {
	return t2 >= t1;
}

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case FETCH_NI_SMELTER_DATA_INIT:
			return {
				...state,
				...action.payload
			};
		case FETCH_NI_SMELTER_DATA: {
			const { data, timestamp } = action.payload;
			if (isResponseValid(state.timestamp, timestamp)) {
				return {
					...state,
					data
				};
			}
			return state;
		}
		case RESET_NI_SMELTER_DATA: {
			return INITIAL_STATE;
		}
		case FETCH_NI_SMELTER_DATA_ERR: {
			const { error, timestamp } = action.payload;
			if (isResponseValid(state.timestamp, timestamp)) {
				return { ...state, error };
			}
			return state;
		}
		default:
			return state;
	}
};
